import { AxiosError } from 'axios'
import axios from 'settings/axios'
import { apiEndpoints } from 'settings/_apiSettings'

interface GetPatientPlansProps {
  username: string
  professionalSlug?: string
}

export interface PlanData {
  id: number,
  name: string,
  status: string,
  default: true,
  reason: string,
  more_info: string,
  created_at: string,
  created_by: {
    full_name: string
  },
  card_number: string,
  cardholder_name: string,
  plan_group: {
    id: 0,
    name: string,
    code: string,
    category: string
  },
  plan_code: string,
  inactivated_by: string,
  inactivated_at: string,
  is_particular: boolean,
  attended_by_professional: boolean
}


interface Response {
  data: PlanData[]
}

export interface PlansData {
  plans: PlanData[]
}

const getPatientPlans = ({
  username,
  professionalSlug,
}: GetPatientPlansProps): Promise<PlansData> => {

  const endpoint = apiEndpoints.PATIENTS_PLANS(username)

  const params = {
    ...(professionalSlug && { professional_slug: professionalSlug }),
  }

  return new Promise<PlansData> ((resolve, reject) => {
    axios.get(endpoint, { params })
      .then((response: Response) => resolve({
        plans: response.data
      }))
      .catch(((err: AxiosError) => reject(err.response.status)))
  })
}

export {
  getPatientPlans
}